import { useState } from 'react';
import * as React from 'react';

import htmlSerializer, {
  HtmlSerializerProps,
} from '../../utils/html-serializer';

import { BrazeCustomEvent } from './prescreen-consumer';

interface CustomPrescreenMultiPageProps {
  content: HtmlSerializerProps['content'][][];
  fallback: HtmlSerializerProps['content'][];
  ariaLabel?: string;
  popupRef?: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  sendBrazeCustomEvent: (payload: BrazeCustomEvent) => void;
  onURLButtonClick: (
    url: string,
    target?: '_self' | '_blank',
    buttonId?: string
  ) => void;
}

const CustomPrescreenMultiPage = ({
  content: contentArray,
  fallback: fallbackContent,
  onClose,
  popupRef,
  sendBrazeCustomEvent,
  onURLButtonClick,
}: CustomPrescreenMultiPageProps): JSX.Element => {
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [fallbackPage, setFallbackPage] = useState<boolean>(false);

  React.useEffect(() => {
    if (pageNumber < 1) return;
    requestAnimationFrame(() => {
      if (!popupRef?.current) return;
      const fElement = popupRef.current?.querySelector<HTMLElement>(
        'h1, span, a, button'
      );
      if (fElement) {
        fElement.setAttribute('tabindex', '-1');
        fElement.focus();
      }
    });
  }, [pageNumber]);

  const handleNextPage = (): void => {
    if (pageNumber < contentArray.length - 1) {
      setPageNumber(pageNumber + 1);
    } else {
      onClose();
    }
  };

  const onFallback = (): void => {
    setFallbackPage(true);
  };

  return (
    <React.Fragment>
      {fallbackPage
        ? fallbackContent.map((content, index) => (
            <React.Fragment key={`multi-step-popup-fallback-${index}`}>
              {htmlSerializer({
                content,
                onClose,
                sendBrazeCustomEvent,
                onURLButtonClick,
                handleNextPage,
                onFallback,
              })}
            </React.Fragment>
          ))
        : (contentArray?.[pageNumber] ?? []).map((content, index) => (
            <React.Fragment key={`multi-step-popup-${index}`}>
              {htmlSerializer({
                content,
                onClose,
                sendBrazeCustomEvent,
                onURLButtonClick,
                handleNextPage,
                onFallback,
              })}
            </React.Fragment>
          ))}
    </React.Fragment>
  );
};

export default CustomPrescreenMultiPage;
